import {Component, Inject, OnInit} from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { constants } from 'src/app/shared/common/contants';


export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;

}

@Component({
    selector: 'app-role-access-permission',
    templateUrl: './role-access-permission.component.html',
    styleUrls: ['./role-access-permission.component.scss'],
    standalone: false
})
export class RoleAccessPermissionComponent implements OnInit {

  showDropdown: boolean  = false;
  selectedAccessValues: number[] = [];

  FormValid: UntypedFormGroup;
  backgroundColorButton = '';
  Accesstypes: any =[];
  UserRoleAccessvalues:any =[];
  isPublic:boolean  ;
  isRestricted:boolean ;
  
  
  assignUserRolePopupData = {
    
    'reportTemplateName': '',
    'reportTemplateId': '',
    'reportAccessType': '',
    'report_rolesIds':'',
    
    
  };


  constructor(public dialogref: MatDialogRef<RoleAccessPermissionComponent>,private localStorageSettings: LocalStorageSettingsService, @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,private service: ReportingServiceService,private snackbar: MatSnackBar,private constants: constants) {   }

  

  ngOnInit(): void {
    
    console.log(this.data);
     this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
     console.log(this.assignUserRolePopupData)

        if (this.assignUserRolePopupData.reportTemplateName != undefined) {
           this.assignUserRolePopupData.reportTemplateName = this.data.edata.reportTemplateName;
           this.assignUserRolePopupData.reportTemplateId = this.data.edata.reportTemplateId;
           this.assignUserRolePopupData.report_rolesIds= this.data.edata.report_rolesIds;
           this.assignUserRolePopupData.reportAccessType=this.data.edata.reportAccessType;
           
        }else{
            console.log(this.assignUserRolePopupData);
          }
    
       this.Useroles();
         
        // Updated the code uncheck the radio button if role is private
    if (this.data.edata.reportAccessType == "Public") {
      this.isPublic = true;
      this.showDropdown = false;
      
      
      
  }
  else if (this.data.edata.reportAccessType == "Restricted") { 
      this.isRestricted = true; // This should be true for the "Restricted To" radio button to be selected
      this.showDropdown = true;
      this.UserRoleAccessvalues = this.data.edata.report_rolesIds.split(',').map(Number);
      console.log(this.UserRoleAccessvalues);
  }
    
       
  }
  

// Update's the selected Roles 
  updateData() {

   
  console.log("-----"+this.assignUserRolePopupData.reportAccessType+"-----"+this.assignUserRolePopupData.report_rolesIds);
  
  if(this.assignUserRolePopupData.report_rolesIds == "" && this.assignUserRolePopupData.reportAccessType ==  "Restricted" )
    {
    this.assignUserRolePopupData.reportAccessType = "Private";
    
    }
    
    console.log(this.assignUserRolePopupData);
    console.log(this.assignUserRolePopupData.reportAccessType);
    this.service.updateReportUserAccess(this.assignUserRolePopupData).subscribe((response) => {
      
      console.log(response);
      if(response.error == true)
      {
        this.snackbar.open(this.constants.Request_Failed ,"OK",{duration:5000});
        close();
        return;
      }
      else{
        this.snackbar.open("Updation Success","OK",{duration:5000});
        this.dialogref.close('updated');
        return;
      }
      
    },
    (error) => {
      console.error('Error while Updating the Access ', error);
    });
    
  
 }
  
  close() {
  this.dialogref.close();
  this.assignUserRolePopupData.report_rolesIds ="";
  this.assignUserRolePopupData.reportTemplateName="";
  this.assignUserRolePopupData.reportTemplateId="";
  this.assignUserRolePopupData.reportAccessType="";
 }

// Fetches the User Roles
Useroles(): void {
    
  const dnsid = this.localStorageSettings.getSettings("dnsName");
  if(dnsid){
    //this.service.
    this.service.getUserRoles(this.localStorageSettings.getSettings("dnsName"))
    .subscribe(
      (response) => {
        this.Accesstypes = response; // Assign fetched user roles to the types array
        console.log(this.Accesstypes);
      },
      (error) => {
        console.error('Error fetching user roles:', error);
      }
    );
    }
  }

  
  
 changeUseroles(e) {
  this.assignUserRolePopupData.report_rolesIds = e.value.join(',');
  console.log(this.assignUserRolePopupData);
  this.assignUserRolePopupData.reportAccessType =  "Restricted";
 }

// Initialize datasetAccessType based on Radio Button
 toggleDropdownforpublic(restricted: boolean) {
    this.showDropdown = false;
    this.assignUserRolePopupData.reportAccessType = "Public";
    this.assignUserRolePopupData.report_rolesIds = "";
    this.UserRoleAccessvalues = [];
  
 }
// Initialize datasetAccessType based on Radio Button 
 toggleDropdownforrestricted(restricted: boolean){

  this.showDropdown = true;
  this.assignUserRolePopupData.reportAccessType =  "Restricted";

 }

}
